import { DICTONARY } from 'const/Dictonary';
import { useCallback, useState } from 'react';
import adminService from 'services/admin';
import { AlertaError } from 'utils/Alertas';

/**
 * Hook para cargar los perfiles de los roles de la empresa
 */

export const useCargaPerfiles = () => {
  // Perfiles de los roles de la empresa
  const [isLoadingPerfiles, setIsLoadingPerfiles] = useState(true);
  const [permisos, setPermisos] = useState([]);
  const cargaPerfiles = useCallback(async roles => {
    try {
      const codigosRolesActuales = Array.isArray(roles) ? roles : [roles];

      const codigosPerfiles = Object.entries(DICTONARY.VALIDACION_ROLES).map(
        ([key, value]) => ({
          nombre: value.NOMBRE,
          codigo_perfil: value.CODIGO_PERFIL,
          codigo_rol: value.CODIGO
        })
      );

      // Buscar el primer perfil que coincida con alguno de los roles
      const perfilEncontrado = codigosPerfiles.find(perfil =>
        codigosRolesActuales.includes(perfil.codigo_rol)
      );

      if (!perfilEncontrado) {
        throw new Error('Ningún rol tiene un perfil válido');
      }

      const codigoPerfil = perfilEncontrado.codigo_perfil;

      try {
        setIsLoadingPerfiles(true);
        const response = await adminService.getPerfil(
          codigoPerfil,
          null,
          DICTONARY.INTERCEPTOR.DESACTIVADO
        );
        // Lista de permisos del perfil
        const permisos = response.data.permisos;
        setPermisos(permisos);
        // Lista de permisos del perfil
        setIsLoadingPerfiles(false);
      } catch (error) {
        console.log('Error al cargar los perfiles', error);
        AlertaError('Error al cargar los perfiles');
      }
    } catch (error) {
      console.log('Error al cargar los perfiles', error);
      AlertaError('Error al cargar los perfiles');
    }
  }, []);

  return {
    isLoadingPerfiles,
    cargaPerfiles,
    permisos,
    setPermisos
  };
};
